import { render, staticRenderFns } from "./FlowName.vue?vue&type=template&id=448261f4&scoped=true&"
import script from "./FlowName.vue?vue&type=script&lang=js&"
export * from "./FlowName.vue?vue&type=script&lang=js&"
import style0 from "./FlowName.vue?vue&type=style&index=0&id=448261f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448261f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Intersect from 'vuetify/lib/directives/intersect'
installDirectives(component, {Intersect})
